import { SharedModule } from '../../shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { take } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { PrintBookingPreviewDialogComponent } from '@tv3/shared/dialogs/print-booking-preview/print-booking-preview-dialog.component'

@Injectable({
  providedIn: SharedModule,
})
export class PrintBookingPreviewDialogService {
  constructor(private dialog: MatDialog) {}

  public open(data: { bookingId: string }) {
    const defaultConfig: MatDialogConfig = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data: { ...data },
      panelClass: ['modal', 'side-modal-lg', 'modal-inquiry-details', 'right'],
    }

    const dialogRef = this.dialog.open(PrintBookingPreviewDialogComponent, defaultConfig)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }
}
